'use client'
import React, { useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';

export default function Legals() {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);


    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main overflow-x-hidden relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px]">

                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Conditions d'Utilisation
                    </h1>
                    <div className=" p-8 w-full max-w-3xl mx-auto rounded shadow-lg">
                        <h1 className="text-2xl font-bold mb-6">Mentions légales de Eurekia</h1>


                        <h2 className="text-xl font-semibold mt-4 mb-4">1. Présentation du site</h2>
                        <p className="mb-4">
                            Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l'économie numérique, dite L.C.E.N., il est porté à la connaissance des utilisateurs et visiteurs du site les présentes mentions légales.
                        </p>

                        <h2 className="text-xl font-semibold mt-4 mb-4">2. Informations légales</h2>
                        <ul className="mb-4">
                            <li>Status du propriétaire : micro entrepreneur</li>
                            <li>Nom de la société : Eurekia</li>
                            <li>Adresse : 10 rue d'Armorique, Arzon 56640</li>
                            <li>SIRET : 88454136800012</li>
                            <li>Email : contact@jeanchoquet.fr</li>
                            <li>Hébergeur : <p className="mb-4">Le site est hébergé par Vercel Inc., dont le siège social est situé au 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis.</p>
                            </li>
                        </ul>

                        <h2 className="text-xl font-semibold mt-4 mb-4">3. Description des services fournis</h2>
                        <p className="mb-4">
                            Le site a pour objet de fournir une information concernant l’ensemble des activités de la société. Eurekia s’efforce de fournir sur le site des informations aussi précises que possible.
                        </p>

                        <h2 className="text-xl font-semibold mt-4 mb-4">4. Propriété intellectuelle et contrefaçons</h2>
                        <p className="mb-4">
                            Eurekia est propriétaire des droits de propriété intellectuelle et détient les droits d’usage sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logos, vidéos, icônes et sons. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Eurekia.
                        </p>
                    </div>
                </section>
                <Footer />

            </main>
        </>
    )
}
